<template>
  <div class="flex w-full flex-col gap-2.5" :data-testid="testId">
    <details
      v-for="group in visibleGroups"
      :key="group.key"
      :open="group.defaultOpen === true"
      class="rounded-lg border border-lightGray30 bg-white"
      :data-testid="`${testId}-group-${group.key}`"
      @toggle="onToggle(group.key, $event)"
    >
      <summary
        class="flex cursor-pointer list-none flex-wrap items-center gap-2.5 px-3.5 py-2.5 font-bold"
      >
        <slot name="title" :group="group">
          <span
            class="rounded-full px-2 py-0.5 text-xs font-medium"
            :class="QUEUE_TONE_PILL_CLASS[group.tone ?? 'neutral']"
          >
            {{ group.title }}
          </span>
        </slot>
        <span class="text-sm font-medium tabular-nums text-neutral50">
          {{ countLabel ? countLabel(group) : `${group.rows.length} itens` }}
        </span>
        <span
          v-if="group.hint"
          class="text-xs font-normal text-neutral50"
          :data-testid="`${testId}-group-${group.key}-hint`"
        >
          {{ group.hint }}
        </span>
      </summary>
      <div class="border-t border-lightGray30">
        <slot :group="group" />
      </div>
    </details>
  </div>
</template>

<script setup lang="ts" generic="T">
import { computed } from 'vue'

import { QUEUE_TONE_PILL_CLASS } from './types'
import type { QueueGroup } from './types'

const props = withDefaults(
  defineProps<{
    groups: QueueGroup<T>[]
    /** Texto da contagem ao lado do título, ex.: `"12 itens"`. */
    countLabel?: (group: QueueGroup<T>) => string
    testId?: string
  }>(),
  { countLabel: undefined, testId: 'queue-grouped-list' }
)

const emit = defineEmits<{ toggle: [key: string, isOpen: boolean] }>()

// Seção vazia é ruído: quem abre a Lista quer ver o que exige ação, não seis
// títulos com zero embaixo.
const visibleGroups = computed(() => props.groups.filter((group) => group.rows.length > 0))

function onToggle(key: string, event: Event): void {
  emit('toggle', key, (event.target as HTMLDetailsElement).open)
}
</script>
